// import React from "react";
// import "./Managerassets.css";
// import logo2 from "../../../assets/images/Picture2.png";

// import {
//   Table, TableBody, TableCell, TableContainer,
//   TableHead, TableRow, Paper, Typography
// } from "@mui/material";

// import { PieChart, Pie, Cell, Tooltip } from "recharts";

// const Managerassets = () => {

//   const charts = [
//     {
//       title: "NOTE BOOK",
//       data: [
//         { name: "Issued", value: 40, color: "#6A5AE0" },
//         { name: "Inventory", value: 20, color: "#FF7676" },
//       ],
//       total: 60,
//     },
//     {
//       title: "PEN",
//       data: [
//         { name: "Issued", value: 20, color: "#6A5AE0" },
//         { name: "Inventory", value: 100, color: "#FF7676" },
//       ],
//       total: 120,
//     },
//   ];

//   return (
//     <div className="assets-page">

//       {/* HEADER */}
//       <header className="assets-header">
//         <div className="header-left">
//           <img src={logo2} alt="Company Logo" />
//           <div>
//             {/* <h2>ENVISION INTEGRATED SERVICES</h2>
//             <p>Private Limited</p> */}
//           </div>
//         </div>
//       </header>

//       {/* CONTENT */}
//       <main className="assets-content">

//         {/* <Typography className="page-title">
//           Asset Overview
//         </Typography> */}

//         {/* TABLE */}
//         <TableContainer component={Paper} className="assets-table">
//           <Table>
//             <TableHead>
//               <TableRow>
//                 {["Description", "Total Assets", "Issued Assets", "Inventory"].map(
//                   (head) => (
//                     <TableCell key={head} align="center" className="table-head">
//                       {head}
//                     </TableCell>
//                   )
//                 )}
//               </TableRow>
//             </TableHead>

//             <TableBody>
//               {[1, 2, 3].map((row) => (
//                 <TableRow key={row}>
//                   {[1, 2, 3, 4].map((cell) => (
//                     <TableCell key={cell} align="center" className="table-cell">
//                       —
//                     </TableCell>
//                   ))}
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         </TableContainer>

//         {/* PIE CHARTS */}
//         <section className="charts-container">
//           {charts.map((chart, index) => (
//             <div key={index} className="chart-card">
//               <Typography className="chart-title">
//                 {chart.title}
//               </Typography>

//               <div className="chart-wrapper">
//                 <PieChart width={220} height={220}>
//                   <Pie
//                     data={chart.data}
//                     cx="50%"
//                     cy="50%"
//                     innerRadius={65}
//                     outerRadius={90}
//                     dataKey="value"
//                   >
//                     {chart.data.map((entry, i) => (
//                       <Cell key={i} fill={entry.color} />
//                     ))}
//                   </Pie>
//                   <Tooltip />
//                 </PieChart>

//                 <span className="chart-total">{chart.total}</span>
//               </div>
//             </div>
//           ))}
//         </section>

//       </main>
//     </div>
//   );
// };

// export default Managerassets;


import React from "react";
import "./Managerassets.css";
import logo2 from "../../../assets/images/Picture2.png";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from "@mui/material";

import { PieChart, Pie, Cell, Tooltip } from "recharts";

const Managerassets = () => {

  // ===== DUMMY TABLE DATA =====
  const tableData = [
    {
      description: "Notebook",
      total: 60,
      issued: 40,
      inventory: 20,
    },
    {
      description: "Pen",
      total: 120,
      issued: 20,
      inventory: 100,
    },
  ];

  // ===== PIE CHART DATA =====
  const charts = [
    {
      title: "NOTE BOOK",
      data: [
        { name: "Issued", value: 40, color: "#6A5AE0" },
        { name: "Inventory", value: 20, color: "#FF7676" },
      ],
      total: 60,
    },
    {
      title: "PEN",
      data: [
        { name: "Issued", value: 20, color: "#6A5AE0" },
        { name: "Inventory", value: 100, color: "#FF7676" },
      ],
      total: 120,
    },
  ];

  return (
    <div className="assets-page">

      {/* ===== HEADER ===== */}
      <header className="assets-header">
        <div className="header-left">
          <img src={logo2} alt="Company Logo" />
        </div>
      </header>

      {/* ===== CONTENT ===== */}
      <main className="assets-content">

        {/* ===== TABLE ===== */}
        <TableContainer component={Paper} className="assets-table">
          <Table>
            <TableHead>
              <TableRow>
                {["Description", "Total Assets", "Issued Assets", "Inventory"].map(
                  (head) => (
                    <TableCell
                      key={head}
                      align="center"
                      className="table-head"
                    >
                      {head}
                    </TableCell>
                  )
                )}
              </TableRow>
            </TableHead>

            <TableBody>
              {tableData.map((row, index) => (
                <TableRow key={index}>
                  <TableCell align="center" className="table-cell">
                    {row.description}
                  </TableCell>
                  <TableCell align="center" className="table-cell">
                    {row.total}
                  </TableCell>
                  <TableCell align="center" className="table-cell">
                    {row.issued}
                  </TableCell>
                  <TableCell align="center" className="table-cell">
                    {row.inventory}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* ===== PIE CHARTS ===== */}
        <section className="charts-container">
          {charts.map((chart, index) => (
            <div key={index} className="chart-card">
              <Typography className="chart-title">
                {chart.title}
              </Typography>

              <div className="chart-wrapper">
                <PieChart width={220} height={220}>
                  <Pie
                    data={chart.data}
                    cx="50%"
                    cy="50%"
                    innerRadius={65}
                    outerRadius={90}
                    dataKey="value"
                  >
                    {chart.data.map((entry, i) => (
                      <Cell key={i} fill={entry.color} />
                    ))}
                  </Pie>
                  <Tooltip />
                </PieChart>

                <span className="chart-total">{chart.total}</span>
              </div>
            </div>
          ))}
        </section>

      </main>
    </div>
  );
};

export default Managerassets;
